if (!customElements.get('mz-reviews')) {
  customElements.define('mz-reviews', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.mz-reviews__rail');
      if (!this.rail || this.abort) return;
      this.abort = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, { signal: this.abort.signal });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.visible = false;
      this.move = direction => {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const step = this.rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).columnGap);
        const atEnd = this.rail.scrollLeft >= max - 3;
        const target = direction > 0 && atEnd ? 0 : direction < 0 && this.rail.scrollLeft < 3 ? max : this.rail.scrollLeft + direction * step;
        this.rail.scrollTo({ left: target, behavior: this.motion.matches ? 'auto' : 'smooth' });
      };
      const stop = () => { this.paused = true; };
      on(this.querySelector('[data-prev]'), 'click', () => { stop(); this.move(-1); });
      on(this.querySelector('[data-next]'), 'click', () => { stop(); this.move(1); });
      on(this.rail, 'pointerdown', stop);
      on(this.rail, 'keydown', stop);
      on(this.rail, 'wheel', stop);
      on(this.motion, 'change', () => { if (this.motion.matches) stop(); });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: 0.25 });
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (!this.paused && this.visible && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.move(1);
      }, 6500);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
